import { validate } from "../utils/estimateValidation"
import { Link, useNavigate } from "react-router-dom"
import { useEffect, useRef, useState } from "react"
import "../css/Estimate.css"
import axios from "axios"
import { path } from "../utils/properties"
import ReCAPTCHA from 'react-google-recaptcha'
import Cookies from "js-cookie"


const Estimate = () => {

    const [estimate, setEstimate] = useState({ name: "", email: "", phone: "", institution: "", subject: "", message: "", accepted: false })
    const [sent, setSent] = useState(false)
    const [info, setInfo] = useState("")
    const navigate = useNavigate()
    const recaptcha = useRef()

    const [cookieConsent, setCookieConsent] = useState(false);

    useEffect(() => {
        const cookieConsent = Cookies.get("cookie-consent");
        if (cookieConsent) {
            const parsedCookie = JSON.parse(cookieConsent)
            if (parsedCookie["Advertising"]["consented"] && parsedCookie["Analytics"]["consented"] && parsedCookie["Social"]["consented"])
                setCookieConsent(true)
        }
    }, []);


    /**/

    const handleValueChange = (e) => {
        const newEstimate = { ...estimate }
        newEstimate[e.target.id] = e.target.value
        setEstimate(newEstimate)
    }

    /**/

    const handleAcceptChange = (e) => {
        const newEstimate = { ...estimate }
        newEstimate[e.target.id] = e.target.checked
        setEstimate(newEstimate)
    }

    /**/

    const handleCreateEstimate = async (e) => {

        e.preventDefault()
        const captchaValue = recaptcha?.current.getValue()

        if (!captchaValue) {
            setInfo("Por favor, verifica el Captcha")
            return
        }

        const { isOk, resultMessage } = validate(estimate)
        setInfo(resultMessage)
        if (!isOk) return

        const res = await axios.post('/api/verify', { captchaValue: captchaValue })
        const { data } = res

        if (!data.success) {
            setInfo('Error al validar Captcha')
            return
        }

        await axios.post(path + "/api/sendestimatemail/:mail", { estimate: estimate }).then(function (response) {
            const status = response.data.status
            const message = response.data.body
            console.log(status, (status === "200"))
            if (status === "200") {
                setSent(true)
                window.scrollTo(0, 0)
            } else
                setInfo(message)
        })

    }

    /**/
    if (sent)
        return (
            <main className="flex col h100 acenter mar-10 pad-30">
                <h2 className="jscenter cspica">Se ha enviado la solicitud correctamente</h2>
                <img alt="Imagen" className="logo-200w" src="/images/estimates/check.gif" ></img>

                <section className="backlink acenter" onClick={() => navigate("/")}>
                    <section className="flex gap-10">
                        <i className="bi bi-arrow-left"></i>
                        <label className="pointer">Volver a la página principal</label>
                    </section>
                </section>

            </main>
        )

    return (
        <main className="h100 flex col acenter vw70 mar-10 pad-30">
            <h2 className="jscenter cspica">Solicitar presupuesto</h2>

            {(cookieConsent) ?

                <form className="flex col gap-10" onSubmit={handleCreateEstimate}>
                    <input maxLength="100" className="generic-input" id="name" type="text" placeholder="Nombre" onChange={handleValueChange} />
                    <input maxLength="100" className="generic-input" id="email" type="text" placeholder="Correo electrónico" onChange={handleValueChange} />
                    <input maxLength="15" className="generic-input" id="phone" type="text" placeholder="Teléfono" onChange={handleValueChange} />
                    <input maxLength="100" className="generic-input" id="institution" type="text" placeholder="Empresa / Institución" onChange={handleValueChange} />
                    <input maxLength="200" className="generic-input" id="subject" type="text" placeholder="Asunto" onChange={handleValueChange} />
                    <textarea maxLength="3000" className="generic-textarea" id="message" type="text" placeholder="Mensaje" onChange={handleValueChange} />
                    <label className="count">{estimate.message.length}/3000</label>
                    <section className="flex gap-10 ">
                        <input id="accepted" type="checkbox" onChange={handleAcceptChange} />
                        <section>
                            <label>Acepto la </label>
                            <Link to="../politica-de-privacidad">Política de privacidad</Link>
                        </section>
                    </section>
                    <label className="cspica fade-in">{info}</label>
                    <ReCAPTCHA ref={recaptcha} sitekey={process.env.REACT_APP_SITE_KEY} />
                    <button className="wine-button pointer">Enviar</button>

                </form>

                :
                <section className="flex col gap-10 acenter jcenter">
                    <article className="cookie-warning">
                        <label>Por favor, acepte las cookies para poder utilizar el formulario de contacto</label>
                    </article>
                </section>}


        </main>
    )

}

export default Estimate
